import { render, staticRenderFns } from "./CartSuggested.vue?vue&type=template&id=7b52478e&scoped=true"
import script from "./CartSuggested.vue?vue&type=script&lang=js"
export * from "./CartSuggested.vue?vue&type=script&lang=js"
import style0 from "./CartSuggested.vue?vue&type=style&index=0&id=7b52478e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b52478e",
  null
  
)

export default component.exports